export enum OfferProductCommentStatus
{
    Created = 1,
    Sent = 2
}

(OfferProductCommentStatus as any).__typeName = 'OfferProductCommentStatus';